import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function FeaturedCategories() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            探索创作分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            八大创作领域，满足你多样化的阅读需求，总有一个领域让你心动
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?cat=${cat.slug}`}
              className="group bg-background-100 rounded-lg p-4 md:p-5 hover:bg-primary-50 transition-all duration-200 border border-transparent hover:border-primary-200 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-primary-200 group-hover:text-primary-700 transition-all duration-200 mb-3">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-medium text-sm md:text-base text-foreground-900 group-hover:text-primary-700 transition-colors duration-200 mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                {cat.description}
              </p>
              <span className="inline-block mt-2 text-xs text-foreground-400">
                {cat.articleCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}